export default "__VITE_ASSET__2fc13bda__"